import React, { Component } from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import GraphicalEnvelope from './envelope/GraphicalEnvelope.js';
import EnvelopeModal from './EnvelopeModal.js';
import {OP_A, OP_B1, OP_B2} from 'constants/envelope-types.js';

class EnvelopeComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showEnvelopeModal: false,
        };
    }

    showEnvelopeModal(show=true) {
        this.setState({showEnvelopeModal: show})
    }

    render() {
        let envelope = this.props.envelope;
        let context = {
            envelopeType: this.props.envelopeType,
        };
        let hasRelease =      this.props.envelopeType !== OP_A &&
                  this.props.envelopeType !== OP_B1 &&
            this.props.envelopeType !== OP_B2 ;
              
        return (
            <div>
              <EnvelopeModal
                envelopeType={this.props.envelopeType}
                envelope={envelope}
                showLevel={this.props.showLevel}
                show={this.state.showEnvelopeModal} hide={() => this.showEnvelopeModal(false)}/>
              <ConditionedComponent condition={this.props.showLevel}>
                <EffectParameterSlider
                  automation={this.props.automation}
                  name={'Level'}
                  parameter={envelope.levelParameter}
                  automationContext={context}
                  sequencerEngine={this.props.sequencerEngine}
                  onParameterChanged={() => []}
                  lfoEnabled={true}
                  isParameter={true}
                  min={-1}
                  max={1}
                  step={0.01}
                  />
              </ConditionedComponent>
              <EffectParameterSlider
                automation={this.props.automation}
                name={'Attack'}
                parameter={envelope.attackParameter}
                automationContext={context}
                sequencerEngine={this.props.sequencerEngine}
                onParameterChanged={() => []}
                lfoEnabled={true}
                isParameter={true}
                min={0}
                max={6000}
                step={1}
                />
                <EffectParameterSlider
                  automation={this.props.automation}
                  name={'Decay'}
                  automationContext={context}
                  sequencerEngine={this.props.sequencerEngine}
                  parameter={envelope.decayParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  lfoEnabled={true}
                  min={0}
                  max={6000}
                  step={1}
                  />
                  <EffectParameterSlider
                    automation={this.props.automation}
                    automationContext={context}
                    name={'Sustain'}
                    parameter={envelope.sustainParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    sequencerEngine={this.props.sequencerEngine}
                    lfoEnabled={true}
                    min={0}
                    max={1}
                    step={0.01}
                    />
              <ConditionedComponent condition={
                  this.props.envelopeType !== OP_A &&
                  this.props.envelopeType !== OP_B1 &&
                  this.props.envelopeType !== OP_B2 
              }>
              <EffectParameterSlider
                automation={this.props.automation}
                sequencerEngine={this.props.sequencerEngine}
                automationContext={context}
                name={'Release'}
                parameter={envelope.releaseParameter}
                onParameterChanged={() => []}
                lfoEnabled={true}
                      isParameter={true}
                min={0}
                max={10000}
                step={1}
              />
            </ConditionedComponent>
              <GraphicalEnvelope hasRelease={hasRelease} envelope={envelope} name={this.props.envelopeType} />
            </div>
        );
    }
}

export default EnvelopeComponent;
